export const LOCALES = {
  EN: "en-GB",
  NL: "nl-NL"
};
